// Botão voltar do Android: pilha global de handlers (ex.: Sheet/modal abertos).
// O topo da pilha é chamado primeiro; pilha vazia → volta no histórico ou minimiza o app.
// Na web nada é registrado.
import { useEffect, useRef } from "react";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";

const stack = [];
let registered = false;

/** Empilha um handler; retorna `pop` para removê-lo. */
export const pushBackHandler = (fn) => {
  const entry = { fn };
  stack.push(entry);
  return () => {
    const i = stack.indexOf(entry);
    if (i !== -1) stack.splice(i, 1);
  };
};

export const handleBackButton = ({ canGoBack }) => {
  const top = stack[stack.length - 1];
  if (top) {
    top.fn();
  } else if (canGoBack) {
    window.history.back();
  } else {
    App.minimizeApp();
  }
};

// Registra o único listener nativo (idempotente). Chamado por services/nativeApp.js
export const registerBackButton = () => {
  if (registered || !Capacitor.isNativePlatform()) return;
  registered = true;
  App.addListener("backButton", handleBackButton);
};

/** Registra `handler` enquanto o componente está montado e `enabled` for true. */
export const useBackButton = (handler, enabled = true) => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) return undefined;
    return pushBackHandler(() => handlerRef.current?.());
  }, [enabled]);
};
